import { ReactNode } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { Sidebar } from '../Sidebar';
import type { AccordionItem } from '@/components/SidebarAccordion/SidebarAccordion';

interface LayoutProps {
  children: ReactNode;
  title: string;
  logo?: ReactNode;
  /**
   * Logo marki (brand) dla domyślnego nagłówka (Header):
   *  - `undefined` → domyślne logo MotoControler,
   *  - `null`      → marka jeszcze nieznana: nagłówek rezerwuje miejsce bez logo,
   *  - `string`    → konkretne logo brandu.
   */
  headerLogoSrc?: string | null;
  sidebarContent?: ReactNode;
  hasSidebar?: boolean;
  navbarContent?: ReactNode;
  footerContent?: ReactNode;
  menuItems?: AccordionItem[];
}

export const Layout = ({
  title,
  children,
  sidebarContent,
  logo,
  headerLogoSrc,
  navbarContent,
  footerContent,
  hasSidebar = false,
  menuItems,
}: LayoutProps) => {
  return (
    <div className="min-h-screen">
      <div className="flex">
        {hasSidebar && (
          <Sidebar logo={logo} menuItems={menuItems}>
            {sidebarContent}
          </Sidebar>
        )}
        <div
          className={
            hasSidebar
              ? 'w-full desktop:ml-64 desktop:w-[calc(100%-16rem)]'
              : 'w-full'
          }
        >
          {navbarContent ? navbarContent : <Header title={title} logoSrc={headerLogoSrc} />}
          <main>{children}</main>
          {footerContent ? footerContent : <Footer />}
        </div>
      </div>
    </div>
  );
};
